<template>
    <div :class="matchIsLive ? 'match is-live' : 'match'" v-if="matchData && teamAway && teamHome">

        <div class="container">
            <div class="grid justify-center">
                <div class="col-lg-8">
                    <div class="match__header">
                        <div class="match__header__teams">
                            <div class="match__header__teams__item">
                                <router-link :to="'/team/' + teamSlug(teamHome) + '/' + league.id"><img :src="teamLogo(teamHome)" :alt="teamHome.teamName"/></router-link>
                                <span>{{ teamHomeName }}</span>
                            </div>
                            <div class="match__header__teams__result">
                                <div v-if="matchHasLiveData && (matchLiveData.matchStatus == '2nd_half' || matchLiveData.matchStatus == 'ended')" class="match__header__teams__result__goals">
                                    <span>{{ matchLiveData.goalsHome }} : {{ matchLiveData.goalsAway }}</span>
                                    <span>{{ matchLiveData.goalsHomeHalftime }} : {{ matchLiveData.goalsAwayHalftime }}</span>
                                </div>
                                <div v-else-if="matchHasLiveData && (matchLiveData.matchStatus == 'halftime' || matchLiveData.matchStatus == '1st_half')" class="match__header__teams__result__goals">
                                    <span>{{ matchLiveData.goalsHomeHalftime }} : {{ matchLiveData.goalsAwayHalftime }}</span>
                                </div>
                                <div v-else-if="matchData.resultCode.startsWith('scheduled') || matchData.resultCode == 'postponed'" class="match__header__teams__result__goals">
                                    - : -
                                </div>
                                <div v-else class="match__header__teams__result__goals">
                                    <span>{{ matchData.goalsHome }} : {{ matchData.goalsAway }}</span>
                                    <span>{{ matchData.goalsHomeHalftime }} : {{ matchData.goalsAwayHalftime }}</span>
                                </div>
                                <div v-if="matchIsLive && matchLiveData.matchStatus != 'halftime'" class="match__header__teams__result__meta match__header__teams__result__meta--live">
                                    {{ matchLiveData.match_time }}' Min
                                </div>
                                <div v-else-if="matchHasLiveData && matchLiveData.matchStatus == 'halftime'" class="match__header__teams__result__meta match__header__teams__result__meta--live">
                                    Halbzeit
                                </div>
                            </div>
                            <div class="match__header__teams__item">
                                <router-link :to="'/team/' + teamSlug(teamAway) + '/' + league.id"><img :src="teamLogo(teamAway)" :alt="teamAway.teamName" /></router-link>
                                <span>{{ teamAwayName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Subnavigation -->
        <div class="tabs tabs--nomargin">
            <div class="container">
                <div class="tabs__content">
                    <div :class="activeTab == 'infos' ? 'tabs__item is-active' : 'tabs__item'" @click="activeTab = 'infos'">
                        Infos
                    </div>
                    <div v-if="articles && articles.length > 0" :class="activeTab == 'berichte' ? 'tabs__item is-active' : 'tabs__item'" @click="activeTab = 'berichte'">
                        Berichte
                    </div>
                    <div v-if="league.competitionType == 1 && matchInPreviewPhase" :class="activeTab == 'statistiken' ? 'tabs__item is-active' : 'tabs__item'" @click="activeTab = 'statistiken'">
                        Statistiken
                    </div>
                    <div :class="activeTab == 'liveticker' ? 'tabs__item is-active' : 'tabs__item'" @click="activeTab = 'liveticker'">
                        Liveticker
                    </div>
                    <div v-if="livestream" :class="activeTab == 'livestream' ? 'tabs__item is-active' : 'tabs__item'" @click="activeTab = 'livestream'">
                        Livestream
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="grid justify-center">

                <div class="col-12" v-if="activeTab == 'infos'">
                    <div class="grid justify-center">

                        <div class="col-sm-7 col-md-6">

                            <!-- Spieldaten -->
                            <div v-if="matchData && matchData.venue"  class="section">
                                <div class="section__title">
                                    <h2>Spieldaten</h2>
                                </div>
                                <div class="list">
                                    <div class="profile__pair">
                                        <div class="profile__pair__label">
                                            {{ matchDayTitle }}
                                        </div>
                                        <div class="profile__pair__value">
                                            {{ matchDayDescription }}
                                        </div>
                                    </div>
                                    <div class="profile__pair">
                                        <div class="profile__pair__label">
                                            Datum
                                        </div>
                                        <div v-if="matchData.resultCode != 'postponed'" class="profile__pair__value">
                                            {{ formatMatchDate(matchData.matchDate) }}
                                        </div>
                                        <div v-else class="profile__pair__value">
                                            Verschoben
                                        </div>
                                    </div>
                                    <div v-if="matchData.resultCode != 'postponed'" class="profile__pair">
                                        <div class="profile__pair__label">
                                            Uhrzeit
                                        </div>
                                        <div class="profile__pair__value">
                                            {{ formatMatchTime(matchData.matchDate) }} Uhr
                                        </div>
                                    </div>
                                    <div v-if="matchData.attendance" class="profile__pair">
                                        <div class="profile__pair__label">
                                            Zuschauer
                                        </div>
                                        <div class="profile__pair__value">
                                            {{ matchData.attendance }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Spielort, venue id 0 is a placeholder, so check for this, too -->
                            <div v-if="matchData && matchData.venue && matchData.venue.id != 0"  class="section">
                                <div class="section__title">
                                    <h2>Spielort</h2>
                                </div>
                                <div class="list">
                                    <VenueInformation :venue="matchData.venue" :ticketShop="matchData.ticketShop"></VenueInformation>
                                </div>
                            </div>

                        </div>

                        <div v-if="matchData && matchData.referees" class="col-sm-5 col-md-4">

                            <!-- Schiedsrichter & Offizielle -->
                            <div class="section">
                                <div class="section__title">
                                    <h2>Schiedsrichter & Offizielle</h2>
                                </div>
                                <div class="list">
                                    <div v-for="r in sortedOfficials" v-bind:key="r.fmpRefereeId" class="list__header">
                                        <div class="list__header__icon list__header__icon--avatar">
                                            <img v-if="r.position.indexOf('referee') != -1" :src="'https://hbf-helper.deinsportplatz.de/images/person/' + r.fmpRefereeId + '/square'" alt="" />
                                            <img v-else src="@/assets/ic_56_avatar.svg" :alt="r.position">
                                        </div>
                                        <div class="list__header__text">
                                            <div class="list__header__text__label">{{ translateRefereeDescription(r.position, r.gender) }}</div>
                                            <div class="list__header__text__value">
                                                {{ r.firstName }} {{ r.lastName }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>

        <div v-if="activeTab == 'liveticker'">
            <iframe :src="livetickerEmbedLink()" id="iframe-hbf-sportradar" width="100%" height="1400" style="border: 0px; width: 100%" class="sportradar-widget"></iframe>
        </div>

        <div class="container">
            <div class="grid justify-center">

                <div v-if="livestream && activeTab == 'livestream'" class="col-sm-12 col-md-10 col-lg-8">
                    <div v-html="livestream.embed_code" class="livestream__wrapper"></div>
                </div>

                <div v-if="activeTab == 'berichte'" class="col-sm-12 col-md-10 col-lg-8">
                    <div>
                        <NewsCard v-for="article in articles" v-bind:key="article.id" :article="article" :horizontal="true" :useSquarePreviewImage="true"/>
                    </div>
                </div>

                <div v-if="teamHomeRanking && teamAwayRanking && activeTab == 'statistiken' && matchInPreviewPhase" class="col-sm-12 col-md-10 col-lg-8">

                    <!-- Statistics -->
                    <div class="list statistics">
                        <div class="statistics__item">
                            <div class="statistics__item__left">
                                <div class="statistics__item__text">
                                    <div class="statistics__item__value">
                                        {{ teamHomeRanking.position }}.
                                    </div>
                                </div>
                            </div>
                            <div class="statistics__item__center">
                                Tabelle
                            </div>
                            <div class="statistics__item__right">
                                <div class="statistics__item__text">
                                    <div class="statistics__item__value">
                                        {{ teamAwayRanking.position }}.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="statistics__item">
                            <div class="statistics__item__left">
                                <div class="statistics__item__text">
                                    <div class="statistics__item__value">
                                        {{ teamHomeRanking.points }}
                                    </div>
                                </div>
                            </div>
                            <div class="statistics__item__center">
                                Punkte
                            </div>
                            <div class="statistics__item__right">
                                <div class="statistics__item__text">
                                    <div class="statistics__item__value">
                                        {{ teamAwayRanking.points }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="statistics__item">
                            <div class="statistics__item__left">
                                <div class="statistics__item__text">
                                    <div class="statistics__item__value">
                                        {{ teamHomeRanking.goalsFor }}:{{ teamHomeRanking.goalsAgainst }}
                                    </div>
                                </div>
                            </div>
                            <div class="statistics__item__center">
                                Tore
                            </div>
                            <div class="statistics__item__right">
                                <div class="statistics__item__text">
                                    <div class="statistics__item__value">
                                        {{ teamAwayRanking.goalsFor }}:{{ teamAwayRanking.goalsAgainst }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="homeTopScorer && awayTopScorer" class="statistics__item">
                            <div @click="openProfile(homeTopScorer)" class="statistics__item__left">
                                <div class="statistics__item__icon">
                                    <img :src="'https://hbf-helper.deinsportplatz.de/images/person/' + homeTopScorer.fmpPlayerId + '/square'">
                                </div>
                                <div class="statistics__item__text">
                                    <div class="statistics__item__label">
                                        {{ homeTopScorer.firstName }} {{ homeTopScorer.lastName }}
                                    </div>
                                    <div class="statistics__item__value">
                                        {{ homeTopScorer.goals }} <span>Tore</span>
                                    </div>
                                </div>
                            </div>
                            <div class="statistics__item__center">
                                Torjägerin
                            </div>
                            <div @click="openProfile(awayTopScorer)" class="statistics__item__right">
                                <div class="statistics__item__icon">
                                    <img :src="'https://hbf-helper.deinsportplatz.de/images/person/' + awayTopScorer.fmpPlayerId + '/square'">
                                </div>
                                <div class="statistics__item__text">
                                    <div class="statistics__item__label">
                                        {{ awayTopScorer.firstName }} {{ awayTopScorer.lastName }}
                                    </div>
                                    <div class="statistics__item__value">
                                        {{ awayTopScorer.goals }} <span>Tore</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="homeTopSaves && awayTopSaves" class="statistics__item">
                            <div @click="openProfile(homeTopSaves)" class="statistics__item__left">
                                <div class="statistics__item__icon">
                                    <img :src="'https://hbf-helper.deinsportplatz.de/images/person/' + homeTopSaves.fmpPlayerId + '/square'">
                                </div>
                                <div class="statistics__item__text">
                                    <div class="statistics__item__label">
                                        {{ homeTopSaves.firstName }} {{ homeTopSaves.lastName }}
                                    </div>
                                    <div class="statistics__item__value">
                                        {{ homeTopSaves.saves }} <span class="hidden-xs-down">Paraden</span>
                                    </div>
                                </div>
                            </div>
                            <div class="statistics__item__center">
                                <span class="hidden-sm-up">Paraden</span>
                            </div>
                            <div class="statistics__item__center">
                                <span class="hidden-xs-down">Torhüterin</span>
                            </div>
                            <div @click="openProfile(awayTopSaves)" class="statistics__item__right">
                                <div class="statistics__item__icon">
                                    <img :src="'https://hbf-helper.deinsportplatz.de/images/person/' + awayTopSaves.fmpPlayerId + '/square'">
                                </div>
                                <div class="statistics__item__text">
                                    <div class="statistics__item__label">
                                        {{ awayTopSaves.firstName }} {{ awayTopSaves.lastName }}
                                    </div>
                                    <div class="statistics__item__value">
                                        {{ awayTopSaves.saves }} <span class="hidden-xs-down">Paraden</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="homeTop7Metres && awayTop7Metres" class="statistics__item">
                            <div @click="openProfile(homeTop7Metres)" class="statistics__item__left">
                                <div class="statistics__item__icon">
                                    <img :src="'https://hbf-helper.deinsportplatz.de/images/person/' + homeTop7Metres.fmpPlayerId + '/square'">
                                </div>
                                <div class="statistics__item__text">
                                    <div class="statistics__item__label">
                                        {{ homeTop7Metres.firstName }} {{ homeTop7Metres.lastName }}
                                    </div>
                                    <div class="statistics__item__value">
                                        {{ homeTop7Metres.sevenMeterGoals }}/{{ homeTop7Metres.sevenMeterGoals + homeTop7Metres.sevenMeterMissed }} <span class="hidden-xs-down">Tore</span>
                                    </div>
                                </div>
                            </div>
                            <div class="statistics__item__center">
                                7-Meter
                            </div>
                            <div @click="openProfile(awayTop7Metres)" class="statistics__item__right">
                                <div class="statistics__item__icon">
                                    <img :src="'https://hbf-helper.deinsportplatz.de/images/person/' + awayTop7Metres.fmpPlayerId + '/square'">
                                </div>
                                <div class="statistics__item__text">
                                    <div class="statistics__item__label">
                                        {{ awayTop7Metres.firstName }} {{ awayTop7Metres.lastName }}
                                    </div>
                                    <div class="statistics__item__value">
                                        {{ awayTop7Metres.sevenMeterGoals }}/{{ awayTop7Metres.sevenMeterGoals + awayTop7Metres.sevenMeterMissed }} <span class="hidden-xs-down">Tore</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Form -->
                    <div class="form">
                        <div v-if="teamHomeRanking.lastMatches" class="form__item form__item--left">
                            <div v-for="o in teamHomeRanking.lastMatches.slice().reverse()" v-bind:key="o.fmpMatchId" :class="_matchResultClass(o, teamHomeRanking)">
                                {{ _matchResultAbbreviation(o, teamHomeRanking) }}
                            </div>
                        </div>
                        <div v-if="teamAwayRanking.lastMatches" class="form__item form__item--right">
                            <div v-for="o in teamAwayRanking.lastMatches" v-bind:key="o.fmpMatchId" :class="_matchResultClass(o, teamAwayRanking)">
                                {{ _matchResultAbbreviation(o, teamAwayRanking) }}
                            </div>
                        </div>
                    </div>

                </div>

            </div> <!-- Close .grid -->
        </div> <!-- Close .container -->

    </div> <!-- Close .team -->
</template>

<script>
import NewsCard from '@/components/NewsCard.vue';
import { teamLogoUrl, matchResultClass, slugify, formatString } from '@/hbf-helper';
import VenueInformation from '@/components/VenueInformation.vue';
import moment from 'moment';

export default {
    name: 'MatchView',
    mounted() {
        this.init(this.$route.params.id, this.$route.params.leagueId, this.$route.query.activeTab);
    },
    data() {
        return {
            leagueId: null,
            competitions: [],
            league: null,
            detailData: null,
            seasonInfo: null,
            table: null,
            matchData: null,
            teamHome: null,
            teamAway: null,
            teamHomeRanking: null,
            teamAwayRanking: null,
            playerData: null,
            teamHomeSquad: null,
            teamAwaySquad: null,
            homeTopScorer: null,
            awayTopScorer: null,
            homeTop7Metres: null,
            awayTop7Metres: null,
            homeTopSaves: null,
            awayTopSaves: null,
            activeTab: "infos",
            livestream: null,
            articles: null,
            liveData: null,
            matchLiveData: null,
            interval: null,
            playOffData: null,
        }
    },
    components: { NewsCard, VenueInformation },
    computed: {
        /* match_status [ not_started, started, aet, ended, postponed, cancelled, abandoned, ap, 1st_half, 2nd_half, 
        halftime, overtime, 1st_extra, 2nd_extra, penalties, pause, awaiting_extra, extra_time_halftime, 
        awaiting_penalties, interrupted, start_delayed, awaiting_extra_time ]
        */
        /* status [ not_started, started, postponed, suspended, cancelled, delayed, live, interrupted, ended, closed ]*/
        matchIsLive() {
            if (this.matchLiveData) {
                return this.matchLiveData.status == "live" && this.matchLiveData.match_time >= 1;
            }
            return false;
        },
        matchHasLiveData() {
            if (this.matchLiveData) {
                return this.matchLiveData.status == "live" || this.matchLiveData.status == "ended" || this.matchLiveData.status == "closed";
            }
            return false;
        },
        matchInPreviewPhase() {
            if (this.matchData) {
                let now = moment();
                return (now < moment(this.matchData.matchDate));
            }
            return false;
        },
        isPlayOffMatch() {
            if (this.playOffData) {
                return this.matchData.fmpPhaseId != this.playOffData.mainPhaseId;
            }
            return false;
        },
        teamHomeName() {
            if (!this.teamHome) { return ""; }
            if (this.league && this.league.competitionType == 2) {
                return this.teamHome.webseitenname;
            }
            return this.teamHome.teamName;
        },
        teamAwayName() {
            if (!this.teamAway) { return ""; }
            if (this.league && this.league.competitionType == 2) {
                return this.teamAway.webseitenname;
            }
            return this.teamAway.teamName;
        },  
        sortedOfficials() {
            if (!this.matchData || !this.matchData.referees) { return []; }
            let refereeSortOrder = {"delegate": 5, "secretary": 4, "first_referee": 1, "second_referee": 2, "timekeeper": 3};
    
            return [...this.matchData.referees].sort((a, b) => {
                return (refereeSortOrder[a.position] || 99) - (refereeSortOrder[b.position] || 99);
            });
        },
        baseUrl() {
            return this.$store.getters.getBaseUrl;
        },
        matchDayTitle() {
            if (this.league.competitionType == 1) {
                return "Spieltag";
            }
            return "Runde";
        },
        matchDayDescription() {
            if (this.playOffData) {
                return formatString(this.playOffData[this.matchData.fmpPhaseId], this.matchData.matchDay);
            }
            else if (this.league.competitionType == 1) {
                return this.matchData.matchDay + ". Spieltag";
            }
            return this.matchData.matchDay + ". Runde";
        },
    },
    methods: {
        loadLiveData() {
            /* re-load live data every 15 seconds */
            console.log("loading live data...");
            this.$store.dispatch("fetchLiveData").then( () => {
                this.liveData = this.$store.getters.getLiveData;
                this.matchLiveData = this.liveData.find(m => m.fmpMatchId == this.matchData.fmpMatchId);
            });
        },
        openProfile(s) {
            if (!s) { return; }
            var profileUrl = "/profile/" + s.fmpPlayerId + "--" + slugify(s.firstName + "-" + s.lastName) + "/" + this.leagueId + "/" + s.fmpTeamId;
            this.$router.push(profileUrl);
        },
        init(matchId, leagueId, activeTab) {
            if (activeTab) { this.activeTab = activeTab; }
            else if (window._hbf_last_match_tab) {
                this.activeTab = window._hbf_last_match_tab;
            } 
            this.leagueId = parseInt(leagueId);

            this.$store.dispatch("fetchData",  {filename: "matches/match_" + matchId + ".json"}).then( (res) => {
                this.matchData = res;

                var now = moment();
                var md = moment(this.matchData.matchDate);
                if (now.isSame(md, 'day')) {
                    this.loadLiveData();
                    this.interval = setInterval(this.loadLiveData, 15000);
                }

                this.$store.dispatch("fetchArticlesForMatch", {fmpMatchId: this.matchData.fmpMatchId}).then((ar) =>{
                    this.articles = ar.items;
                });
                            
                this.$store.dispatch("fetchCompetitions").then( () => {
                    this.competitions = this.$store.getters.getCompetitions;
                    this.league = Object.assign({}, this.competitions.find(el => el.id == this.leagueId));

                    if (!this.league) { return; }
                    if (this.league.fmpSeasonId == null) {
                        this.league.fmpSeasonId = this.matchData.fmpSeasonId;
                    }

                    this.$store.dispatch("fetchData",  {filename: "leagues/league_" + this.league.fmpSeasonId + ".json"}).then( (res) => {
                        this.detailData = res;
                        var season_key = this.league.fmpSeasonId;
                        this.seasonInfo = this.detailData.seasons.find(s => s.fmpSeasonId == season_key);
                        this.teamHome = this.detailData.teams.find(t => t.fmpTeamId == this.matchData.fmpTeamHomeId);
                        this.teamAway = this.detailData.teams.find(t => t.fmpTeamId == this.matchData.fmpTeamAwayId);
                    });

                    this.$store.dispatch("fetchData",  {filename: "leagues/playoff_" + this.league.fmpSeasonId + ".json"}).then( (res) => {
                        this.playOffData = res;
                    });

                    if (this.league.competitionType == 1) {
                        this.$store.dispatch("fetchData",  {filename: "tables/table_" + this.league.fmpSeasonId + ".json"}).then( (res) => {
                            this.table = res.table;
                            this.teamHomeRanking = this.table.find(t => t.fmpTeamId == this.matchData.fmpTeamHomeId);
                            this.teamAwayRanking = this.table.find(t => t.fmpTeamId == this.matchData.fmpTeamAwayId);
                        });
                    }

                    this.$store.dispatch("fetchFile",  {filename: "livestreams/ls_" + this.league.fmpSeasonId + "_" + this.matchData.fmpMatchId + ".json"}).then( (res) => {
                        this.livestream = res;
                    });

                    this.$store.dispatch("fetchData",  {filename: "players/players_" + this.league.fmpSeasonId + ".json"}).then( (res) => {
                        this.playerData = res;
                        if (!this.playerData || !this.playerData.playerStatistics) { return; }
                        this.teamHomeSquad = this.playerData.playerStatistics.filter(p => p.fmpTeamId == this.matchData.fmpTeamHomeId);
                        this.teamAwaySquad = this.playerData.playerStatistics.filter(p => p.fmpTeamId == this.matchData.fmpTeamAwayId);
                        this.homeTopScorer = this.topScorer(this.teamHomeSquad);
                        this.awayTopScorer = this.topScorer(this.teamAwaySquad);
                        this.homeTop7Metres = this.top7Metres(this.teamHomeSquad);
                        this.awayTop7Metres = this.top7Metres(this.teamAwaySquad);
                        this.homeTopSaves = this.topSaves(this.teamHomeSquad);
                        this.awayTopSaves = this.topSaves(this.teamAwaySquad);
                    });


                });
        
            });
        },
        formatMatchDate(d) {
            let newDate = moment(d).locale("de")
            return newDate.format("dd., DD.MM.YYYY");
        },
        formatMatchTime(d) {
            let newTime = moment(d).locale("de")
            return newTime.format("HH:mm");
        },
        topScorer(squad) {
            if (squad != null) {
                return squad.sort((s1, s2) => s2.goals - s1.goals)[0];
            }
        },
        top7Metres(squad) {
            if (squad != null) {
                return squad.sort((s1, s2) => s2.sevenMeterGoals - s1.sevenMeterGoals || s2.sevenMeterMissed - s1.sevenMeterMissed )[0];
            }
        },
        topSaves(squad) {
            if (squad != null) {
                return squad.sort((s1, s2) => s2.saves - s1.saves)[0];
            }
        },
        teamLogo(team) {
            return teamLogoUrl(team, 200, this.baseUrl, this.league.fmpSeasonId);
        },
        _matchResultClass(o, t) {
            return "form__bullet form__bullet--" + matchResultClass(o, t);
        },
        _matchResultAbbreviation(o ,t) {
            let outcome = matchResultClass(o ,t);
            return {"draw": "U", "lose": "N", "win": "S"}[outcome];
        },
        /* eslint-disable no-unused-vars */
        translateRefereeDescription(d, gender) {
            /*if (gender == "male") {
                return {"secretary": "Sekretär", "first_referee": "Schiedsrichter", "second_referee": "2. Schiedsrichter", "timekeeper": "Zeitnehmer"}[d];
            }
            else {
                return {"secretary": "Sekretärin", "first_referee": "Schiedsrichterin", "second_referee": "2. Schiedsrichterin", "timekeeper": "Zeitnehmerin"}[d];
            }*/
            return {"delegate": "Delegierte/r", "secretary": "Sekretär/in", "first_referee": "Schiedsrichter/in", "second_referee": "Schiedsrichter/in", "timekeeper": "Zeitnehmer/in"}[d];
        },
        teamSlug(team) {
            return team.fmpTeamId + "--" + slugify(team.teamName);
        },
        livetickerEmbedLink() {
            let lt = "https://cs.betradar.com/ls/handball/?/hbf/de/Europe:Berlin/page/scleague/handball#matchId=";
            var tid;
            let mid = this.matchData.matchId.split(":").slice(-1);
            switch (this.league.id) {
                case 1:
                    tid = 742;
                    break;
                case 2:
                    tid = 18835;
                    break;
                case 3:
                    tid = 1620;
                    break;
                default:
                    break;
            }

            return lt + mid + "&tournamentId=" + tid;
        }
    },
    beforeRouteLeave: function(to, from, next) {
        if (this.interval) { clearInterval(this.interval); }
        window._hbf_last_match_tab = this.activeTab;
        next();
    }
}
</script>

<style lang="scss">
    .match {

        &__header {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 8px 0 26px;

            &__teams {
                display: flex;
                justify-content: center;

                &__item {
                    display: flex;
                    flex-direction: column;
                    width: calc((100% - 104px) / 2);
                    align-items: center;
                    font-size: 13px;
                    line-height: 11px;
                    font-weight: 700;
                    color: rgba($colorBlack, .48);
                    letter-spacing: -0.25px;
                    text-align: center;
                    
                    span {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        padding-bottom: 4px;
                        margin-bottom: -4px;
                        max-width: 100%;
                    }

                    @media (min-width: $breakpoint-sm) {
                        font-size: 18px;
                        line-height: 14px;
                        letter-spacing: -0.35px;
                        width: auto;
                        flex: 1;
                    }

                    img {
                        width: 64px;
                        height: 64px;
                        object-fit: contain;
                        object-position: center center;
                        margin-bottom: 18px;

                        @media (min-width: $breakpoint-sm) {
                            width: 128px;
                            height: 128px;
                            margin-bottom: 40px;
                        }
                    }
                }

                &__result {
                    display: flex;
                    flex-shrink: 0;
                    flex-direction: column;
                    align-items: center;
                    width: 104px;

                    @media (min-width: $breakpoint-sm) {
                        width: 220px;
                    }

                    &__goals {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        font-size: 30px;
                        letter-spacing: -1px;
                        font-weight: 800;
                        color: $colorBlack;
                        height: 64px;
                        margin-bottom: 19px;

                        .is-live & {
                            color: $colorLive;
                        }

                        @media (min-width: $breakpoint-sm) {
                            height: 128px;
                            margin-bottom: 40px;
                            font-size: 64px;
                            letter-spacing: -1px;
                        }

                        span:nth-child(2) {
                            position: absolute;
                            bottom: -3px;
                            font-size: 13px;
                            color: rgba($colorBlack, .48);
                            word-spacing: 3px;

                            @media (min-width: $breakpoint-sm) {
                                font-size: 20px;
                                word-spacing: 6px;
                                ottom: -4px;
                            }

                            .is-live & {
                                color: rgba($colorLive, .48);
                            }
                        }
                    }

                    &__meta {
                        position: relative;
                        font-size: 13px;
                        line-height: 11px;
                        font-weight: 700;
                        color: rgba($colorBlack, .48);
                        letter-spacing: -0.25px;
                        text-transform: uppercase;

                        @media (min-width: $breakpoint-sm) {
                            font-size: 18px;
                            line-height: 14px;
                            letter-spacing: -0.35px;
                            padding-right: 12px;
                        }

                        &--live {
                            color: $colorLive;
                            padding-right: 10px;

                            &:after {
                                content: '';
                                position: absolute;
                                right: 0;
                                top: 2.5px;
                                width: 6px;
                                height: 6px;
                                border-radius: 50%;
                                background: $colorLive;

                                @media (min-width: $breakpoint-sm) {
                                    width: 7px;
                                    height: 7px;
                                    top: 3px;
                                }
                            }
                        }
                    }
                }
            }

            &__button {
                display: inline-flex;
                align-items: center;
                margin: 24px auto -16px;
                padding: 10px 20px 10px 16px;
                border-radius: 20px;
                background: $colorWhite;
                box-shadow: 0 0 0 1px rgba($colorBlack, .06), 0 8px 24px 0 rgba($colorBlack, .08), 0 2px 8px 0 rgba($colorBlack, .02);
                font-size: 11px;
                line-height: 11px;
                font-weight: 700;
                color: $colorBlack;
                text-transform: uppercase;
                transition: all .2s ease-in-out;
                text-decoration: none;

                @media (min-width: $breakpoint-sm) {
                    margin: 32px auto 8px;
                    padding: 14px 20px 14px 16px;
                    border-radius: 24px;
                    font-size: 14px;
                }

                &:hover {
                    box-shadow: 0 0 0 1px rgba($colorBlack, .06), 0 12px 24px 0 rgba($colorBlack, .1), 0 2px 8px 0 rgba($colorBlack, .02);
                    transform: translateY(-2px);
                    cursor: pointer;
                }

                img {
                    margin-right: 8px;

                    @media (min-width: $breakpoint-sm) {
                        margin-right: 12px;
                    }
                }
            }

        }
    }

    .statistics {

        @media (min-width: $breakpoint-sm) {
            padding: 20px 40px;
            margin-top: 24px;
        }

        &__item {
            display: flex;
            align-items: center;
            padding: 15px 0;

            @media (min-width: $breakpoint-sm) {
                padding: 25px 0;
            }

            &:not(:last-child) {
                box-shadow: inset 0 -1px 0 0 rgba($colorBlack, .08);
            }

            &__left {
                display: flex;
                align-items: center;
                flex: 1;
            }

            &__center {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 11px;
                line-height: 11px;
                font-weight: 800;
                color: rgba($colorBlack, .48);
                text-transform: uppercase;

                @media (min-width: $breakpoint-sm) {
                    font-size: 14px;
                    font-weight: 700;
                }
            }

            &__right {
                display: flex;
                align-items: center;
                flex: 1;
                justify-content: flex-start;
                flex-direction: row-reverse;
            }

            &__icon {
                display: flex;
                margin: -9px 8px -9px 0;
                cursor: pointer;

                @media (min-width: $breakpoint-sm) {
                    margin: -9px 16px -9px 0;
                }

                .statistics__item__right & {
                    margin: -9px 0 -9px 8px;

                    @media (min-width: $breakpoint-sm) {
                        margin: -9px 0 -9px 16px;
                    }
                }

                img {
                    width: 32px;
                    height: 32px;
                    object-fit: cover;
                    object-position: center center;
                    border-radius: 50%;

                    @media (min-width: $breakpoint-sm) {
                        width: 48px;
                        height: 48px;
                    }
                }
            }

            &__text {
                display: flex;
                flex-direction: column;

                .statistics__item__right & {
                    align-items: flex-end;
                } 
            }

            &__label {
                display: none;
                font-size: 11px;
                line-height: 11px;
                font-weight: 700;
                color: rgba($colorBlack, .48);
                margin-bottom: 10px;
                text-transform: uppercase;

                @media (min-width: $breakpoint-sm) {
                    display: flex;

                    + .statistics__item__value {
                        font-size: 26px;
                    }
                }
            }

            &__value {
                font-size: 14px;
                line-height: 14px;
                font-weight: 700;
                color: $colorBlack;

                @media (min-width: $breakpoint-sm) {
                    font-size: 20px;

                    span {
                        font-size: 17px;
                    }
                }
            }
        }
    }

    .form {
        display: flex;
        width: 100%;
        margin: 24px auto;

        @media (min-width: $breakpoint-sm) {
            margin: 32px auto;
        }

        &__item {
            position: relative;
            width: 50%;
            display: flex;
            justify-content: space-between;
            padding: 0 32px 0 0;

            @media (min-width: $breakpoint-sm) {
                padding: 0 128px 0 0;
            }

            &:before {
                content: '';
                position: absolute;
                z-index: -1;
                left: 0;
                top: 9px;
                width: calc(100% - 16px);
                height: 2px;
                background: rgba($colorBlack, .08);

                @media (min-width: $breakpoint-sm) {
                    top: 15px;
                    width: calc(100% - 64px);
                }
            }

            &:after {
                content: '';
                position: absolute;
                z-index: -1;
                top: 5px;
                right: 10px;
                width: 6px;
                height: 10px;
                background: url('../assets/form-arrow.svg');
                background-size: cover;

                @media (min-width: $breakpoint-sm) {
                    width: 9px;
                    height: 15px;
                    top: 8.5px;
                    right: 55px;
                }
            }

            &--right {
                display: flex;
                flex-direction: row-reverse;
                padding: 0 0 0 32px;

                @media (min-width: $breakpoint-sm) {
                    padding: 0 0 0 128px;
                }

                &:before {
                    right: 0;
                    left: inherit;
                }

                &:after {
                    left: 10px;
                    right: inherit;
                    transform: rotate(180deg);

                    @media (min-width: $breakpoint-sm) {
                        width: 9px;
                        height: 15px;
                        top: 8.5px;
                        left: 55px;
                    }
                }
            }
        }

        &__bullet {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            color: $colorWhite;
            font-size: 11px;
            font-weight: 700;

            @media (min-width: $breakpoint-sm) {
                font-size: 14px;
                width: 32px;
                height: 32px;
            }

            &--win {
                background: $colorSuccess;
            }

            &--draw {
                background: #B7B6B7;
            }

            &--lose {
                background: $colorDanger;
            }
        }
    }

    .livestream__wrapper {
        position: relative;
        padding-bottom: 56.25%;
        /* 16:9, for an aspect ratio of 1:1 change to this value to 100% */ 

        iframe {
            position: absolute !important;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>

<style lang="scss" scoped>
    @media (min-width: $breakpoint-sm) {
        .tabs__content {
            justify-content: center;
        }

        iframe {
            margin-top: -12px;
        }
    }

    .list__header {
        &:not(:last-child) {
            box-shadow: inset 0 -1px 0 0 rgba($colorBlack, .04);
        }
    }

    .section {
        height: auto;

        &:first-of-type {
            margin-bottom: 24px;

            @media (min-width: $breakpoint-sm) {
                margin-bottom: 16px;
            }
        }
    }

    ::v-deep .tabs {
        margin-bottom: 12px !important;
    }

    iframe {
        margin-top: -12px;
    }
</style>